import { Injectable } from '@angular/core';
import { ApiCommodityFamily, ApiLocationGroup } from '@app/infrastructure/api/models';
import {
  ResetStoreManagerViewState,
  SaveStoreManagerViewState,
  SetStoreManagerListConfig,
} from '@app/routes/index/store-manager/index/_actions';
import { Action, Selector, State, StateContext } from '@ngxs/store';

export const CURRENT_STORE_MANAGER_LIST_VERSION = 4;

interface StoreManagerListStateModel {
  version: number;
  commodityId?: string;
  commodityFamily?: ApiCommodityFamily;
  locationGroup?: ApiLocationGroup;
  hideZeroBalance?: boolean;
  regionId?: number;
  searchText?: string;
  expandedLocationId?: string;
  scrollPosition: number;
}

export const STORE_MANAGER_LIST_STATE_DEFAULTS: StoreManagerListStateModel = {
  version: CURRENT_STORE_MANAGER_LIST_VERSION,
  hideZeroBalance: true,
  scrollPosition: 0,
};

@State<StoreManagerListStateModel>({
  name: 'StoreManagerList',
  defaults: STORE_MANAGER_LIST_STATE_DEFAULTS,
})
@Injectable()
export class StoreManagerListState {
  @Selector()
  static commodityId(state: StoreManagerListStateModel): string | undefined {
    return state.commodityId;
  }

  @Selector()
  static commodityFamily(state: StoreManagerListStateModel): ApiCommodityFamily | undefined {
    return state.commodityFamily;
  }

  @Selector()
  static locationGroup(state: StoreManagerListStateModel): ApiLocationGroup | undefined {
    return state.locationGroup;
  }

  @Selector()
  static hideZeroBalance(state: StoreManagerListStateModel): boolean | undefined {
    return state.hideZeroBalance;
  }

  @Selector()
  static regionId(state: StoreManagerListStateModel): number | undefined {
    return state.regionId;
  }

  @Selector()
  static searchText(state: StoreManagerListStateModel): string | undefined {
    return state.searchText;
  }

  @Selector()
  static expandedLocationId(state: StoreManagerListStateModel): string | undefined {
    return state.expandedLocationId;
  }

  @Selector()
  static scrollPosition(state: StoreManagerListStateModel): number {
    return state.scrollPosition;
  }

  @Action(SetStoreManagerListConfig)
  setStoreManagerListConfig(
    ctx: StateContext<StoreManagerListStateModel>,
    action: SetStoreManagerListConfig,
  ) {
    ctx.patchState({
      commodityId: action.config.commodityId ?? undefined,
      commodityFamily: action.config.commodityFamily ?? undefined,
      locationGroup: action.config.locationGroup ?? undefined,
      hideZeroBalance: action.config.hideZeroBalance ?? undefined,
      regionId: action.config.regionId ?? undefined,
      searchText: action.config.searchText ?? undefined,
    });
  }

  @Action(SaveStoreManagerViewState)
  saveViewState(ctx: StateContext<StoreManagerListStateModel>, action: SaveStoreManagerViewState) {
    ctx.patchState({
      expandedLocationId: action.expandedLocationId,
      scrollPosition: action.scrollPosition,
    });
  }

  @Action(ResetStoreManagerViewState)
  resetViewState(ctx: StateContext<StoreManagerListStateModel>) {
    ctx.patchState({
      expandedLocationId: undefined,
      scrollPosition: 0,
    });
  }
}
